import { instance } from '../config/axios';
import { urls } from '../config/urls';
import { hasLiveRefreshToken } from '../config/session';
import { AxiosRequestConfig } from 'axios';

interface AuthHelpers {
  login: (email: string, password: string, site_name: string) => Promise<any>;
  reset:(email:string) => Promise<any>;
  resetPwd: (pass: string, key: string) => Promise<any>;
  activateUser: (pass: string, key: string) => Promise<any>;
  userProfile: () => Promise<any>;
  logout: () => void;
  loggedIn: () => boolean;
  onChange: () => void;
}

export const { server } = urls;

const authHelpers: AuthHelpers = {
  login(email: string, password: string, site_name: string): Promise<any> {
    return instance.post(server.auth.login, { email, password, site_name });
  },

  reset (email: string):Promise<any> {
    return instance.post(`${server.auth.reset}`, email);
  },
  
  resetPwd(pass: string, key: string): Promise<any> {
    return instance.post(`${server.auth.reset}/${key}`, pass);
  },

  activateUser(pass: string, key: string): Promise<any> {
    return instance.post(`${server.auth.activate}/${key}`,  pass );
  },

  userProfile(): Promise<any> {
    return instance.get(`${server.auth.user_profile}`)
  },

  logout(): void {
    const token = sessionStorage.getItem('token');
    const refreshToken = sessionStorage.getItem('refresh');
    sessionStorage.clear();

    // Ends the session on the server too. Fire-and-forget: the local logout must
    // not wait on the network, and a dead refresh token (400) is expected when we
    // got here because a refresh failed.
    if (refreshToken) {
      instance
        .post(
          server.auth.logout,
          { refresh_token: refreshToken },
          {
            headers: token ? { Authorization: `JWT ${token}` } : {},
            _skipAuthRefresh: true,
          } as AxiosRequestConfig,
        )
        .catch(() => {});
    }
  },

  // Logged in for as long as the refresh token is valid. An expired access token
  // does not end the session; the next request renews it.
  loggedIn(): boolean {
    if (hasLiveRefreshToken()) return true;
    if (sessionStorage.getItem('token') || sessionStorage.getItem('refresh')) {
      this.logout();
    }
    return false;
  },

  onChange(): void {
  }
};

export default authHelpers;
